module.exports = __webpack_public_path__ + "static/media/maintenance-2d1c24b0f9c6b4faf5ade8eb32ccea42.gif";